import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import './Location.css';
import MarketingdashboardAside from './MarketingdashboardAside';

const Location = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchDate, setSearchDate] = useState('');
  const [searchName, setSearchName] = useState('');
  const [isScrolled, setIsScrolled] = useState(false);

  const tableWrapperRef = useRef(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://cleezoclass.com:8443/api/getSchoolData');
        console.log("API Raw Data:", response.data); // Debugging API response
  
        const formattedData = response.data.map(item => ({
          ...item,
          followupdate: item.followupdate
            ? new Date(item.followupdate).toISOString().split('T')[0] // Convert to "YYYY-MM-DD"
            : "No Follow-up Date"
        }));
  
        console.log("Formatted Data:", formattedData); // Debug formatted data
  
        setData(formattedData);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  
  // Handle scroll event for "Scroll to Top" button
  const handleScroll = () => {
    if (tableWrapperRef.current) {
      setIsScrolled(tableWrapperRef.current.scrollTop > 200);
    }
  };

  // Scroll to top of the table
  const scrollToTop = () => {
    if (tableWrapperRef.current) {
      tableWrapperRef.current.scrollTop = 0;
    }
  };

  // Format duration from seconds to HH:MM format
  const formatDuration = (seconds) => {
    if (!seconds || isNaN(seconds)) return "0 mins";  
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return hours > 0 ? `${hours}:${minutes.toString().padStart(2, "0")} hrs` : `${minutes} mins`;
  };

  // Filter data based on search inputs
  const filteredData = data.filter((item) => {
    const dateMatch = searchDate ? item.followupdate?.includes(searchDate) : true;
    const nameMatch = searchName ? item.school_name?.toLowerCase().includes(searchName.toLowerCase()) : true;
    return dateMatch && nameMatch;
  });

  return (
    <div className="location-container-wrapper mainBlock">
      <MarketingdashboardAside />
      {/* Header with Search Inputs */}
      <div className="location-header-wrapper">
        <h1 className="location-header-title">School Follow-up Data</h1>
        <div className="location-search-fields">
          <input
            type="date"
            className="location-search-input"
            value={searchDate}
            onChange={(e) => setSearchDate(e.target.value)}
          />
          <input
            type="text"
            className="location-search-input"
            placeholder="Enter School Name"
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
          />
        </div>
      </div>

      {/* Table or Loading Message */}
      {loading ? (
        <div className="location-loading-message">Loading...</div>
      ) : (
        <div className="location-table-wrapper" ref={tableWrapperRef} onScroll={handleScroll}>
          <table className="location-data-table">
            <thead className="sticky-header">
              <tr>
                <th className="location-th">Emp ID</th>
                <th className="location-th">School Name</th>
                <th className="location-th">School Address</th>
                <th className="location-th">Contact Mail</th>
                <th className="location-th">Designation</th>
                <th className="location-th">Mobile</th>
                <th className="location-th">Person Name</th>
                <th className="location-th">Follow-up Date</th>
                <th className="location-th">Interest</th>
                <th className="location-th">Time Duration</th>
              </tr>
            </thead>
            <tbody>
  {filteredData.length > 0 ? (
    filteredData.map((item, index) => {
      console.log("Follow-up Date for", item.school_name, ":", item.followupdate); // Debugging

      return (
        <tr key={index} className="location-table-row">
          <td>{item.empId}</td>
          <td>{item.school_name}</td>
          <td>{item.school_address}</td>
          <td>{item.contactperson_mailid}</td>
          <td>{item.contactperson_designation}</td>
          <td>{item.contactperson_mobileno}</td>
          <td>{item.contactperson_name}</td>
          <td>
          <td>{item.followupdate && item.followupdate !== "No Follow-up Date" ? item.followupdate : "No Follow-up Date"}</td>
          </td>
          <td>{item.interest_shown}</td>
          <td>{formatDuration(item.duration_seconds)}</td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="10" className="no-data-message">No data available.</td>
    </tr>
  )}
</tbody>

          </table>
        </div>
      )}

      {/* Scroll to Top Button */}
      {isScrolled && (
        <div className="scroll-to-top-icon" onClick={scrollToTop}>
          ↑
        </div>
      )}
    </div>
  );
};

export default Location;
